import { auth, googleProvider, microsoftProvider } from "../firebase";
import { useNavigate } from "react-router-dom";

import { Box, Button, Container, Typography, Paper, TextField } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import MicrosoftIcon from "@mui/icons-material/Microsoft";
import { useState } from "react";

import { useAuth } from '../contexts/FirebaseAuthContext';


const logoImage = "/Ergoman.png";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { signIn, signInWithGoogle, signInWithMicrosoft, tenantId } = useAuth();

  const loginWithGoogle = async () => {
    try {
      await signInWithGoogle();
      navigate("/dashboard"); // Redirect after login
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  const loginWithMicrosoft = async () => {
    try {
      await signInWithMicrosoft();
      navigate("/dashboard"); // Redirect after login
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  const loginWithEmail = async () => {
    try {
      await signIn(auth, email, password);
      navigate("/dashboard");
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  return (
    <Container maxWidth="xs"  >
      <Paper elevation={3} sx={{ p: 4, mt: 8, textAlign: "center", borderRadius: 2 }}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Sign in
        </Typography>
        <TextField
          label="Email"
          variant="outlined"
          fullWidth
          sx={{ mt: 2 }}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          label="Password"
          type="password"
          variant="outlined"
          fullWidth
          sx={{ mt: 2 }}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button
          variant="contained"
          onClick={loginWithEmail}
          sx={{ mt: 2 }}
          fullWidth
        >
          Sign in with Email
        </Button>
        <Button
          variant="contained"
          startIcon={<GoogleIcon />}
          onClick={loginWithGoogle}
          sx={{ mt: 2, backgroundColor: "#4285F4", color: "white", ":hover": { backgroundColor: "#357ae8" } }}
          fullWidth
        >
          Sign in with Google
        </Button>
        <Button
          variant="contained"
          startIcon={<MicrosoftIcon />}
          onClick={loginWithMicrosoft}
          sx={{ mt: 2, backgroundColor: "#0078D4", color: "white", ":hover": { backgroundColor: "#005A9E" } }}
          fullWidth
        >
          Sign in with Microsoft
        </Button>

        <Box component="img" src={logoImage} alt="Logo" sx={{ width: 200, mt: 2 }} />

      </Paper>
    </Container>
  );
};

export default Login;
